module.exports = __webpack_public_path__ + "img/6.9cb058b5.jpg";